module.exports = __webpack_public_path__ + "files/5278808a4d6b13c98d9484109547b749.png";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/alpha.png
// module id = 316
// module chunks = 60